import {
  GroupOutlined,
  MailOutlined,
  QuestionCircleOutlined,
  ReadOutlined,
  SettingOutlined,
  TagOutlined,
  TeamOutlined,
  TrophyOutlined,
  UnorderedListOutlined,
  UserOutlined,
} from '@ant-design/icons';
import {
  LiveHelpOutlined,
  PolicyOutlined,
  SecurityRounded,
} from '@material-ui/icons';
import BookmarkOutlinedIcon from '@material-ui/icons/BookmarkOutlined';
import React from 'react';

export const adminRoutes = [
  {
    path: '/users/:userId',
    name: 'user.detail',
    title: 'Admin-User-Detail',
    exact: true,
    permission: '',
    component: React.lazy(() => import('@/pages/users/Detail')),
    isLayout: false,
    isMenu: false,
    icon: <UserOutlined />,
    isGuarded: true,
  },

  //
  // {
  //   path: '/setting',
  //   name: 'setting.list',
  //   title: 'Settings',
  //   exact: true,
  //   permission: '',
  //   component: React.lazy(() => import('@/pages/settings/List')),
  //   isLayout: false,
  //   isMenu: true,
  //   icon: <UnorderedListOutlined />,
  //   isGuarded: true,
  // },

  {
    path: '/faq',
    name: 'faq',
    title: 'FAQ',
    exact: true,
    permission: '',
    component: React.lazy(() => import('@/pages/accounts/FAQ')),
    isLayout: false,
    isMenu: false,
    isGuarded: false,
  },

  {
    path: '/term-condition',
    name: 'term-condition',
    title: 'Term Condition',
    exact: true,
    permission: '',
    component: React.lazy(() => import('@/pages/accounts/TermCondition')),
    isLayout: false,
    isMenu: false,
    isGuarded: false,
  },

  {
    path: '/policy',
    name: 'policy',
    title: 'Policy',
    exact: true,
    permission: '',
    component: React.lazy(() => import('@/pages/accounts/Policy')),
    isLayout: false,
    isMenu: false,
    isGuarded: false,
  },

  {
    path: '/courses',
    name: 'courses',
    title: 'Courses',
    exact: true,
    permission: '',
    component: React.lazy(() => import('@/pages/courses/List')),
    isLayout: false,
    isMenu: true,
    icon: <UnorderedListOutlined />,
    isGuarded: false,
  },
  {
    path: '/graders',
    name: 'graders',
    title: 'Grade Perspectives',
    exact: true,
    permission: '',
    component: React.lazy(() => import('@/pages/graders/List')),
    isLayout: false,
    isMenu: true,
    isGuarded: true,
    icon: (
      <div style={{ display: 'inline-flex', verticalAlign: 'middle' }}>
        <LiveHelpOutlined style={{ fontSize: '17' }} />
      </div>
    ),
  },
  {
    path: '/units',
    name: 'units',
    title: 'Course Units',
    exact: true,
    permission: '',
    component: React.lazy(() => import('@/pages/units/List')),
    isLayout: false,
    isMenu: true,
    icon: <TagOutlined />,
    isGuarded: false,
  },
  {
    path: '/questions',
    name: 'questions',
    title: 'Questions',
    exact: true,
    permission: '',
    component: React.lazy(() => import('@/pages/questions/List')),
    isLayout: false,
    isMenu: true,
    icon: <QuestionCircleOutlined />,
    isGuarded: false,
  },
  {
    path: '/questions/create',
    name: 'questions-create',
    title: 'Create Question',
    exact: true,
    permission: '',
    component: React.lazy(() => import('@/pages/questions/Create')),
    isLayout: false,
    isMenu: false,
    isGuarded: false,
  },
  {
    path: '/questions/:id',
    name: 'questions-edit',
    title: 'Edit Question',
    exact: true,
    permission: '',
    component: React.lazy(() => import('@/pages/questions/Edit')),
    isLayout: false,
    isMenu: false,
    isGuarded: false,
  },
  {
    path: '/vocabularies',
    name: 'vocabularies',
    title: 'Vocabularies',
    exact: true,
    permission: '',
    component: React.lazy(() => import('@/pages/vocabularies/List')),
    isLayout: false,
    isMenu: true,
    icon: <ReadOutlined />,
    isGuarded: false,
  },
  {
    path: '/free-codes',
    name: 'free-code.list',
    title: 'Free Codes',
    exact: true,
    permission: '',
    component: React.lazy(() => import('@/pages/codes/List')),
    isLayout: false,
    isMenu: true,
    icon: (
      <div style={{ display: 'inline-flex', verticalAlign: 'middle' }}>
        <BookmarkOutlinedIcon style={{ fontSize: '17' }} />
      </div>
    ),
    isGuarded: true,
  },

  {
    path: '/admin-faq',
    name: 'faq',
    title: 'FAQs',
    exact: true,
    permission: '',
    component: React.lazy(() => import('@/pages/faq/List')),
    isLayout: false,
    isMenu: true,
    isGuarded: true,
    icon: (
      <div style={{ display: 'inline-flex', verticalAlign: 'middle' }}>
        <LiveHelpOutlined style={{ fontSize: '17' }} />
      </div>
    ),
  },

  {
    path: '/admin-policy',
    name: 'policy',
    title: 'Privacy Policy',
    exact: true,
    permission: '',
    component: React.lazy(() => import('@/pages/policy/List')),
    isLayout: false,
    isMenu: true,
    isGuarded: true,
    icon: (
      <div style={{ display: 'inline-flex', verticalAlign: 'middle' }}>
        <SecurityRounded style={{ fontSize: '17' }} />
      </div>
    ),
  },

  {
    path: '/admin-term-condition',
    name: 'term-condition',
    title: 'Terms & Conditions',
    exact: true,
    permission: '',
    component: React.lazy(() => import('@/pages/term/List')),
    isLayout: false,
    isMenu: true,
    isGuarded: true,
    icon: (
      <div style={{ display: 'inline-flex', verticalAlign: 'middle' }}>
        <PolicyOutlined style={{ fontSize: '17' }} />
      </div>
    ),
  },

  {
    path: '/users',
    name: 'users',
    title: 'Users',
    exact: true,
    permission: '',
    component: React.lazy(() => import('@/pages/users/List')),
    isLayout: false,
    isMenu: true,
    icon: <TeamOutlined />,
    isGuarded: false,
  },

  // {
  //   path: '/districts',
  //   name: 'districts',
  //   title: 'Districts',
  //   exact: true,
  //   permission: '',
  //   component: React.lazy(() => import('@/pages/districts/List')),
  //   isLayout: false,
  //   isMenu: true,
  //   icon: <GroupOutlined />,
  //   isGuarded: false,
  // },

  // {
  //   path: '/schools',
  //   name: 'schools',
  //   title: 'Schools',
  //   exact: true,
  //   permission: '',
  //   component: React.lazy(() => import('@/pages/schools/List')),
  //   isLayout: false,
  //   isMenu: true,
  //   icon: <TeamOutlined />,
  //   isGuarded: false,
  // },

  {
    path: '/badges',
    name: 'badge.list',
    title: 'Badges',
    exact: true,
    permission: '',
    component: React.lazy(() => import('@/pages/badges/List')),
    isLayout: false,
    isMenu: true,
    icon: <TrophyOutlined />,
    isGuarded: true,
  },
  {
    path: '/email-delivery',
    name: 'email-delivery',
    title: 'Email Delivery',
    exact: true,
    permission: '',
    component: React.lazy(() => import('@/pages/email-delivery/List')),
    isLayout: false,
    isMenu: true,
    icon: <MailOutlined />,
    isGuarded: true,
  },
  {
    path: '/setting',
    name: 'setting',
    title: 'Setting',
    exact: true,
    permission: '',
    component: React.lazy(() => import('@/pages/settings/List')),
    isLayout: false,
    isMenu: true,
    icon: <SettingOutlined />,
    isGuarded: true,
  },

];

export const defaultRoutes = [
  {
    path: '/',
    name: 'login',
    title: 'Login - Admin',
    exact: true,
    permission: '',
    component: React.lazy(() => import('@/pages/accounts/Login')),
    isLayout: false,
    isMenu: false,
    isGuarded: false,
  },
  // {
  //   path: '/register',
  //   name: 'register',
  //   title: 'Register - Admin',
  //   exact: true,
  //   permission: '',
  //   component: React.lazy(() => import('@/pages/accounts/Register')),
  //   isLayout: false,
  //   isMenu: false,
  //   isGuarded: false,
  // },
  {
    path: '/verify-email/:token',
    name: 'verify-email',
    title: 'Verify Email',
    exact: true,
    permission: '',
    component: React.lazy(() => import('@/pages/accounts/VerifyEmail')),
    isLayout: false,
    isMenu: false,
    isGuarded: false,
  },
  {
    path: '/verify-change-email/:token',
    name: 'verify-change-email',
    title: 'Verify Change Email',
    exact: true,
    permission: '',
    component: React.lazy(() => import('@/pages/accounts/VerifyChangeEmail')),
    isLayout: false,
    isMenu: false,
    isGuarded: true,
  },
  {
    path: '/confirm-change-email/:token',
    name: 'confirm-change-email',
    title: 'Confirm Change Email',
    exact: true,
    permission: '',
    component: React.lazy(() => import('@/pages/accounts/ConfirmChangeEmail')),
    isLayout: false,
    isMenu: false,
    isGuarded: true,
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    title: 'Forgot Password',
    exact: true,
    permission: '',
    component: React.lazy(() => import('@/pages/accounts/ForgotPassword')),
    isLayout: false,
    isMenu: false,
    isGuarded: false,
  },

  {
    path: '/reset-password/:token',
    name: 'reset-password',
    title: 'Reset Password',
    exact: true,
    permission: '',
    component: React.lazy(() => import('@/pages/accounts/ResetPassword')),
    isLayout: false,
    isMenu: false,
    isGuarded: false,
  },
];
